import { TemplateNotFound } from "../../components/icons/Icon2";
import NoDataFound from "../../components/updatedComponents/NoDataFound/NoDataFound";
import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
import {
  formatDateTime,
  getStatusColor,
  LastActionCell,
} from "../../Utils/Utils";
import styles from "./VoucherList.module.css";

const VoucherList = ({
  mode,
  voucherTab,
  headerData,
  loading,
  orderData,
  handleClick,
}) => {
  const voucherFields = {
    Order: [
      (d) => `${formatDateTime(d.orderDate)}`,
      "orderId",
      (d) => `${d.storeName}, ${d.city}`,
      "shippingType",
      "createdBy",
      "ordermanager",
      "orderType",
      "totalAmount",
      "status",
      (d) => <LastActionCell lastAction={d.lastAction} />,
    ],

    "Sale Order": [
      (d) => `${formatDateTime(d.orderDate)}`,
      "orderId",
      (d) => `${d.storeName}, ${d.city}, ${d.dealerId}`,
      "createdBy",
      "ordermanager",
      "packinghManager",
      "orderType",
      "methodName",
      "pendingAmount",
      "partnerName",
      "status",
      (d) => <LastActionCell lastAction={d.lastAction} />,
    ],
    Purchase: [
      "voucherDate",
      "voucherNo",
      "supplierName",
      "warehouse",
      "totalAmount",
      "status",
      "totalItems",
    ],
    Adjustment: [
      "voucherDate",
      "voucherNo",
      "warehouse",
      "totalAmount",
      "status",
      "totalItems",
    ],
    Transfer: [
      "voucherDate",
      "voucherNo",
      "fromWarehouse",
      "toWarehouse",
      "totalAmount",
      "status",
      "totalItems",
    ],
    "Production & Sale": [
      (d) => `${formatDateTime(d.voucherDate)}`,
      "voucherId",
      (d) => `${d.storeName}, ${d.city}`,
      "warehousename",
      "createdBy",
      "ordermanager",
      "voucherType",
      "methodName",
      "partnerName",
      "status",
      (d) => <LastActionCell lastAction={d.lastAction} />,
    ],
  };

  const fields = voucherFields[voucherTab] || [];

  const columnWeights = {
    Order: [1.2, 0.8, 1.5, 1, 1, 1, 1, 1, 1, 1],
    "Sale Order": [1.2, 0.8, 2.5, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    Purchase: [1, 1, 1, 1, 1, 1, 1],
    Adjustment: [1, 1, 1, 1, 1, 1],
    Transfer: [1, 1, 1, 1, 1, 1, 1],
    "Production & Sale": [1.2, 0.8, 1.5, 1, 1, 1, 1, 1, 1, 1, 1],
  };

  const columnCount = headerData?.length || fields.length;
  const weights = columnWeights[voucherTab];
  const gridTemplateColumns =
    weights && weights.length === columnCount
      ? weights.map((w) => `${w}fr`).join(" ")
      : `repeat(${columnCount}, 1fr)`;

  // console.log("order data ", orderData);

  return (
    <>
      <li
        className={`${styles.order_data_list_row_header} ${
          mode ? styles.order_data_list_row_header_dark : ""
        }`}
        style={{ gridTemplateColumns }}
      >
        {headerData.map((h) => (
          <div className={styles.entry} key={h} title={h}>
            {h}
          </div>
        ))}
      </li>

      <div className={styles.order_data_list_container}>
        {loading ? (
          <div>
            <Skeleton
              lines={15}
              thickness={5}
              additionalStyles={{ marginBottom: "0px", marginTop: "0px" }}
            />
          </div>
        ) : (
          <>
            {orderData?.length === 0 ? (
              <div className={styles.no_data}>
                <NoDataFound
                  icon={<TemplateNotFound />}
                  textTitle={`No Data Found`}
                />
              </div>
            ) : (
              <>
                {orderData?.map((d, index) => (
                  <li
                    key={d.orderId || d.voucherId || `order-${index}`}
                    className={`${styles.order_data_list_row} ${
                      mode ? styles.order_data_list_row_dark : ""
                    }
                               
                     ${
                       d.orderType === "Direct Collect"
                         ? styles.direct_collect
                         : d.orderType === "Master Order"
                           ? styles.master_order
                           : ""
                     }
                   
                    `}
                    style={{ gridTemplateColumns }}
                    onClick={() => {
                      handleClick(d);
                    }}
                  >
                    {fields.map((field, fieldIndex) => (
                      <div
                        key={`${d.orderId || d.voucherId || index}-${fieldIndex}`}
                        className={styles.entry}
                        style={
                          field === "status" || field === "orderType"
                            ? {
                                color: getStatusColor(d[field]),
                                textTransform: "capitalize",
                              }
                            : {}
                        }
                        // title={
                        //   typeof field === "function" ? field(d) : d[field]
                        // }
                      >
                        {typeof field === "function" ? field(d) : d[field]}
                      </div>
                    ))}
                  </li>
                ))}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default VoucherList;
